import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

import {useNationalityStore} from '@/store/nationality';
import Loading from '@/components/Loading.vue';
import {computed, watch} from 'vue';
import ErrorDisplay from './ErrorDisplay.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'SelectNationality',
  props: {
    modelValue: {},
    showLabel: { type: Boolean }
  },
  emits: {'update:modelValue': (data: string) => typeof data === 'string'},
  setup(__props: any, { expose: __expose, emit: __emit }) {

const store = useNationalityStore();
store.fetch().catch(console.error);
const props = __props;

const emits = __emit;

const internalValue = computed({
  get() {
    return props.modelValue || '';
  },
  set(newVal: string) {
    emits('update:modelValue', newVal);
    return;
  },
});

watch(() => store.data, (newData) => {
  if (newData.length === 0) return;

  internalValue.value = newData[0].Kennzeichen;
});

__expose({
  store,
  internalValue,
  fetch,
  props,
  Loading,
  ErrorDisplay,
});

return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_unref(store).error)
    ? (_openBlock(), _createBlock(ErrorDisplay, {
        key: 0,
        message: _unref(store).error.message,
        loading: _unref(store).loading,
        onRetry: _unref(store).fetch
      }, null, 8, ["message", "loading", "onRetry"]))
    : (_unref(store).loading)
      ? (_openBlock(), _createBlock(Loading, { key: 1 }))
      : (_openBlock(), _createBlock(_component_v_autocomplete, {
          key: 2,
          label: "Land",
          class: "mt-3 mb-2",
          modelValue: internalValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
          "item-title": "Staat",
          "item-value": "Kennzeichen",
          items: _unref(store).data,
          loading: _unref(store).loading,
          placeholder: "--- Land wählen ---",
          "return-object": false
        }, null, 8, ["modelValue", "items", "loading"]))
}
}

})